<template>
  <div class="monthly-comparison-mobile" style="scrollbar-width: none !important; -ms-overflow-style: none !important;">
    <!-- 时间范围切换按钮 -->
    <button
      class="time-range-btn"
      @click="toggleTimeRange"
      :class="{ 'active': timeRange === 'all' }"
      :style="timeRange === 'all' ? 
        'position: fixed !important; right: 15px !important; bottom: 135px !important; width: 40px !important; height: 40px !important; border-radius: 50% !important; background-color: #409eff !important; color: white !important; border: none !important; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important; font-size: 20px !important; font-weight: bold !important; display: flex !important; align-items: center !important; justify-content: center !important; z-index: 9999 !important; cursor: pointer !important; transition: all 0.3s ease !important;' : 
        'position: fixed !important; right: 15px !important; bottom: 135px !important; width: 40px !important; height: 40px !important; border-radius: 50% !important; background-color: rgba(255, 255, 255, 0.5) !important; color: #409eff !important; border: none !important; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important; font-size: 20px !important; font-weight: bold !important; display: flex !important; align-items: center !important; justify-content: center !important; z-index: 9999 !important; cursor: pointer !important; transition: all 0.3s ease !important;'"
    >
      A
    </button>
    
    <!-- 数据概览 -->
    <el-card class="data-card overview-card" v-loading="loading" :body-style="{ padding: '10px' }">
      <div slot="header" class="card-header">
        <span>数据概览 ({{ currentMonthLabel }})</span>
      </div>
      <div class="overview-content">
        <div class="overview-grid" style="display: grid !important; grid-template-columns: repeat(3, 1fr) !important; grid-template-rows: repeat(2, 1fr) !important; gap: 10px !important; width: 100% !important; padding: 0 !important; min-height: 200px !important;">
                      <div class="stat-item" style="text-align: center !important; padding: 10px 6px !important; border-radius: 8px !important; background-color: #ffffff !important; height: 85px !important; display: flex !important; flex-direction: column !important; justify-content: center !important; min-height: 85px !important; border: 1px solid #f0f0f0 !important; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important; transition: all 0.2s ease !important;">
            <div class="stat-label" style="font-size: 12px !important; color: #606266 !important; margin-bottom: 6px !important; font-weight: 500 !important;">场次</div>
            <div class="stat-value" style="font-size: 18px !important; font-weight: bold !important; color: #303133 !important; margin-bottom: 4px !important;">{{ latestStats.gameCount || 0 }}</div>
            <div class="stat-trend" :class="getTrendClass(latestStats.gameCountTrend)" :style="{ fontSize: '10px', fontWeight: '500', color: latestStats.gameCountTrend > 0 ? '#67C23A' : latestStats.gameCountTrend < 0 ? '#F56C6C' : '#909399' }">
              {{ formatTrend(latestStats.gameCountTrend) }}
            </div>
          </div>
          <div class="stat-item" style="text-align: center !important; padding: 10px 6px !important; border-radius: 8px !important; background-color: #ffffff !important; height: 85px !important; display: flex !important; flex-direction: column !important; justify-content: center !important; min-height: 85px !important; border: 1px solid #f0f0f0 !important; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important; transition: all 0.2s ease !important;">
            <div class="stat-label" style="font-size: 12px !important; color: #606266 !important; margin-bottom: 6px !important; font-weight: 500 !important;">得分率</div>
            <div class="stat-value" style="font-size: 18px !important; font-weight: bold !important; color: #303133 !important; margin-bottom: 4px !important;">{{ formatPercent(latestStats.scoreRate) }}</div>
            <div class="stat-trend" :class="getTrendClass(latestStats.scoreRateTrend)" :style="{ fontSize: '10px', fontWeight: '500', color: latestStats.scoreRateTrend > 0 ? '#67C23A' : latestStats.scoreRateTrend < 0 ? '#F56C6C' : '#909399' }">
              {{ formatTrend(latestStats.scoreRateTrend) }}
            </div>
          </div>
          <div class="stat-item" style="text-align: center !important; padding: 10px 6px !important; border-radius: 8px !important; background-color: #ffffff !important; height: 85px !important; display: flex !important; flex-direction: column !important; justify-content: center !important; min-height: 85px !important; border: 1px solid #f0f0f0 !important; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important; transition: all 0.2s ease !important;">
            <div class="stat-label" style="font-size: 12px !important; color: #606266 !important; margin-bottom: 6px !important; font-weight: 500 !important;">订正率</div>
            <div class="stat-value" style="font-size: 18px !important; font-weight: bold !important; color: #303133 !important; margin-bottom: 4px !important;">{{ formatPercent(latestStats.fixRate) }}</div>
            <div class="stat-trend" :class="getTrendClass(latestStats.fixRateTrend)" :style="{ fontSize: '10px', fontWeight: '500', color: latestStats.fixRateTrend > 0 ? '#67C23A' : latestStats.fixRateTrend < 0 ? '#F56C6C' : '#909399' }">
              {{ formatTrend(latestStats.fixRateTrend) }}
            </div>
          </div>
          <div class="stat-item" style="text-align: center !important; padding: 10px 6px !important; border-radius: 8px !important; background-color: #ffffff !important; height: 85px !important; display: flex !important; flex-direction: column !important; justify-content: center !important; min-height: 85px !important; border: 1px solid #f0f0f0 !important; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important; transition: all 0.2s ease !important;">
            <div class="stat-label" style="font-size: 12px !important; color: #606266 !important; margin-bottom: 6px !important; font-weight: 500 !important;">复盘率</div>
            <div class="stat-value" style="font-size: 18px !important; font-weight: bold !important; color: #303133 !important; margin-bottom: 4px !important;">{{ formatPercent(latestStats.reviewRate) }}</div>
            <div class="stat-trend" :class="getTrendClass(latestStats.reviewRateTrend)" :style="{ fontSize: '10px', fontWeight: '500', color: latestStats.reviewRateTrend > 0 ? '#67C23A' : latestStats.reviewRateTrend < 0 ? '#F56C6C' : '#909399' }">
              {{ formatTrend(latestStats.reviewRateTrend) }}
            </div>
          </div>
          <div class="stat-item" style="text-align: center !important; padding: 10px 6px !important; border-radius: 8px !important; background-color: #ffffff !important; height: 85px !important; display: flex !important; flex-direction: column !important; justify-content: center !important; min-height: 85px !important; border: 1px solid #f0f0f0 !important; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important; transition: all 0.2s ease !important;">
            <div class="stat-label" style="font-size: 12px !important; color: #606266 !important; margin-bottom: 6px !important; font-weight: 500 !important;">掌握率</div>
            <div class="stat-value" style="font-size: 18px !important; font-weight: bold !important; color: #303133 !important; margin-bottom: 4px !important;">{{ formatPercent(latestStats.masteryRate) }}</div>
            <div class="stat-trend" :class="getTrendClass(latestStats.masteryRateTrend)" :style="{ fontSize: '10px', fontWeight: '500', color: latestStats.masteryRateTrend > 0 ? '#67C23A' : latestStats.masteryRateTrend < 0 ? '#F56C6C' : '#909399' }">
              {{ formatTrend(latestStats.masteryRateTrend) }}
            </div>
          </div>
          <div class="stat-item" style="text-align: center !important; padding: 10px 6px !important; border-radius: 8px !important; background-color: #ffffff !important; height: 85px !important; display: flex !important; flex-direction: column !important; justify-content: center !important; min-height: 85px !important; border: 1px solid #f0f0f0 !important; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important; transition: all 0.2s ease !important;">
            <div class="stat-label" style="font-size: 12px !important; color: #606266 !important; margin-bottom: 6px !important; font-weight: 500 !important;">排位率</div>
            <div class="stat-value" style="font-size: 18px !important; font-weight: bold !important; color: #303133 !important; margin-bottom: 4px !important;">Top {{ formatPercent(latestStats.rankRate) }}</div>
            <div class="stat-trend" :class="getTrendClass(-latestStats.rankRateTrend)" :style="{ fontSize: '10px', fontWeight: '500', color: -latestStats.rankRateTrend > 0 ? '#67C23A' : -latestStats.rankRateTrend < 0 ? '#F56C6C' : '#909399' }">
              {{ formatTrend(-latestStats.rankRateTrend) }}
            </div>
          </div>
          <div class="stat-item" style="text-align: center !important; padding: 10px 6px !important; border-radius: 8px !important; background-color: #ffffff !important; height: 85px !important; display: flex !important; flex-direction: column !important; justify-content: center !important; min-height: 85px !important; border: 1px solid #f0f0f0 !important; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important; transition: all 0.2s ease !important;">
            <div class="stat-label" style="font-size: 12px !important; color: #606266 !important; margin-bottom: 6px !important; font-weight: 500 !important;">
              平均难度
              <el-tooltip effect="dark" placement="top" popper-class="difficulty-tooltip" :popper-style="{ width: '250px', maxWidth: '250px', minWidth: '250px' }" @show="fixTooltipWidth">
                <div slot="content" class="difficulty-tooltip-content">
                  <div class="difficulty-levels">
                    <div class="difficulty-level">
                      <span class="level-color" style="display: inline-block !important; width: 14px !important; height: 14px !important; border-radius: 2px !important; margin-right: 6px !important; background-color: #F56C6C !important; border: 1px solid rgba(255, 255, 255, 0.3) !important;"></span>
                      <span class="level-range">00.00 ~ 14.29%:</span>
                      <span class="level-name">红题（很简单）</span>
                    </div>
                    <div class="difficulty-level">
                      <span class="level-color" style="display: inline-block !important; width: 14px !important; height: 14px !important; border-radius: 2px !important; margin-right: 6px !important; background-color: #E6A23C !important; border: 1px solid rgba(255, 255, 255, 0.3) !important;"></span>
                      <span class="level-range">14.29 ~ 28.58%:</span>
                      <span class="level-name">橙题（简单）</span>
                    </div>
                    <div class="difficulty-level">
                      <span class="level-color" style="display: inline-block !important; width: 14px !important; height: 14px !important; border-radius: 2px !important; margin-right: 6px !important; background-color: #F7BA2A !important; border: 1px solid rgba(255, 255, 255, 0.3) !important;"></span>
                      <span class="level-range">28.58 ~ 42.87%:</span>
                      <span class="level-name">黄题（较易）</span>
                    </div>
                    <div class="difficulty-level">
                      <span class="level-color" style="display: inline-block !important; width: 14px !important; height: 14px !important; border-radius: 2px !important; margin-right: 6px !important; background-color: #67C23A !important; border: 1px solid rgba(255, 255, 255, 0.3) !important;"></span>
                      <span class="level-range">42.87 ~ 57.15%:</span>
                      <span class="level-name">绿题（中等）</span>
                    </div>
                    <div class="difficulty-level">
                      <span class="level-color" style="display: inline-block !important; width: 14px !important; height: 14px !important; border-radius: 2px !important; margin-right: 6px !important; background-color: #409EFF !important; border: 1px solid rgba(255, 255, 255, 0.3) !important;"></span>
                      <span class="level-range">57.15 ~ 71.44%:</span>
                      <span class="level-name">蓝题（较难）</span>
                    </div>
                    <div class="difficulty-level">
                      <span class="level-color" style="display: inline-block !important; width: 14px !important; height: 14px !important; border-radius: 2px !important; margin-right: 6px !important; background-color: #8E44AD !important; border: 1px solid rgba(255, 255, 255, 0.3) !important;"></span>
                      <span class="level-range">71.44 ~ 85.72%:</span>
                      <span class="level-name">紫题（很难）</span>
                    </div>
                    <div class="difficulty-level">
                      <span class="level-color" style="display: inline-block !important; width: 14px !important; height: 14px !important; border-radius: 2px !important; margin-right: 6px !important; background-color: #2C3E50 !important; border: 1px solid rgba(255, 255, 255, 0.3) !important;"></span>
                      <span class="level-range">85.72 ~ 100%:</span>
                      <span class="level-name">黑题（极难）</span>
                    </div>
                  </div>
                </div>
                <i class="el-icon-question" style="cursor: pointer; margin-left: 4px; font-size: 14px;"></i>
              </el-tooltip>
            </div>
            <div class="stat-value" style="font-size: 18px !important; font-weight: bold !important; color: #303133 !important; margin-bottom: 4px !important;">
              {{ formatPercent(latestStats.avgDifficulty) }}
            </div>
            <div class="stat-trend" :class="getTrendClass(latestStats.avgDifficultyTrend)" :style="{ fontSize: '10px', fontWeight: '500', color: latestStats.avgDifficultyTrend > 0 ? '#67C23A' : latestStats.avgDifficultyTrend < 0 ? '#F56C6C' : '#909399' }">
              {{ formatTrend(latestStats.avgDifficultyTrend) }}
            </div>
          </div>
        </div>
      </div>
    </el-card>
    
    <!-- 月度数据表格 -->
    <el-card class="data-card table-card" v-loading="loading" style="--el-card-body-padding: 0;" :body-style="{ padding: '0' }">
      <div slot="header" class="card-header">
        <span>月度数据表格</span>
      </div>
      <div class="table-wrapper">
        <el-table
          :data="tableData"
          border
          stripe
          style="min-width: 100%; font-size: 12px !important;"
          :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontSize: '12px' }"
          :cell-style="{ fontSize: '12px' }"
          :min-width="(tableColumns.length * 100) + 60"
        >
          <el-table-column prop="month" label="月份" width="60" fixed="left" align="center">
            <template slot="header" slot-scope="scope">
              <span>月份</span>
            </template>
            <template slot-scope="scope">
              <div class="month-display">
                <div class="month-day">{{ getMonthDay(scope.row.month) }}</div>
                <div class="month-year">{{ getMonthYear(scope.row.month) }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(column, index) in tableColumns"
            :key="column"
            :label="column"
            align="center"
            min-width="90"
          >
            <template slot-scope="scope">
              <div v-if="column === '平均难度' && scope.row[`value${index}`] !== '-'">
                <el-tag
                  :style="{ 
                    backgroundColor: getDifficultyColorByPercentage(extractNumericValue(scope.row[`value${index}`]) * 100),
                    borderColor: getDifficultyColorByPercentage(extractNumericValue(scope.row[`value${index}`]) * 100),
                    color: 'white'
                  }"
                  :title="getDifficultyLevelByPercentage(extractNumericValue(scope.row[`value${index}`]) * 100)"
                  size="mini">
                  <span style="font-weight: bold">{{ formatPercentWithoutHTML(scope.row[`value${index}`]) }}</span>
                </el-tag>
              </div>
              <div v-else-if="scope.row[`value${index}`] !== '-'" v-html="scope.row[`value${index}`]"></div>
              <div v-if="scope.row[`trend${index}`] !== null" class="trend-indicator" :class="getTrendClass(scope.row[`trend${index}`])" :style="getTrendColorStyle(scope.row[`trend${index}`])">
                {{ formatTrendArrow(scope.row[`trend${index}`]) }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    
    <!-- 数据可视化 -->
    <el-card class="data-card chart-card" v-loading="loading" style="--el-card-body-padding: 20px 0;" :body-style="{ padding: '20px 0' }">
      <div slot="header" class="card-header">
        <span>指标综合分析</span>
      </div>
      <div class="chart-container" ref="chartContainer" style="height: 320px !important; width: 100% !important; min-height: 320px !important; display: block !important; position: relative !important;"></div>
    </el-card>
    
    <!-- 版权信息 -->
    <div style="text-align: center; color: #909399; font-size: 12px; margin-top: 16px; line-height: 1.5; padding-bottom: 16px;">
      Copyright © 2024 OIer之路 All rights reserved.<br>闽ICP备2025095302号-1
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import request from '@/utils/request'

export default {
  name: 'MonthlyComparisonMobile',
  data() {
    return {
      loading: false,
      timeRange: 'recent', // 默认显示最近一年的数据
      currentMonthLabel: '',
      latestStats: {
        gameCount: 0,
        gameCountTrend: 0,
        scoreRate: 0,
        scoreRateTrend: 0,
        fixRate: 0,
        fixRateTrend: 0,
        reviewRate: 0,
        reviewRateTrend: 0,
        masteryRate: 0,
        masteryRateTrend: 0,
        rankRate: 0,
        rankRateTrend: 0,
        avgDifficulty: 0,
        avgDifficultyTrend: 0
      },
      months: [],
      tableColumns: [],
      tableData: [],
      monthlyData: [
        { 
          month: '场次', 
          type: 'gameCount',
          values: [],
          trends: []
        },
        { 
          month: '得分率', 
          type: 'scoreRate',
          values: [],
          trends: []
        },
        { 
          month: '订正率', 
          type: 'fixRate',
          values: [],
          trends: []
        },
        { 
          month: '复盘率', 
          type: 'reviewRate',
          values: [],
          trends: []
        },
        { 
          month: '排位率', 
          type: 'rankRate',
          values: [],
          trends: []
        },
        { 
          month: '掌握率', 
          type: 'masteryRate',
          values: [],
          trends: []
        },
        { 
          month: '平均难度', 
          type: 'avgDifficulty',
          values: [],
          trends: []
        }
      ],
      chart: null
    }
  },
  mounted() {
    this.fetchData()
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
    if (this.chart) {
      this.chart.dispose()
    }
  },
  methods: {
    toggleTimeRange() {
      this.timeRange = this.timeRange === 'recent' ? 'all' : 'recent'
      this.handleTimeRangeChange()
    },
    getMonthDay(monthStr) {
      // 从 "2025/07" 格式中提取月份部分
      const parts = monthStr.split('/')
      return parts.length > 1 ? parts[1] : monthStr
    },
    getMonthYear(monthStr) {
      // 从 "2025/07" 格式中提取年份部分
      const parts = monthStr.split('/')
      return parts.length > 1 ? parts[0] : ''
    },
    getValueColorStyle(value) {
      // 提取数值，处理百分比格式
      let numericValue = 0
      if (typeof value === 'string') {
        // 移除HTML标签和百分比符号，提取数字
        const cleanValue = value.replace(/<[^>]*>/g, '').replace(/%/g, '')
        numericValue = parseFloat(cleanValue) || 0
      } else if (typeof value === 'number') {
        numericValue = value
      }
      
      // 根据数值设置颜色
      if (numericValue > 0) {
        return { color: '#67C23A' } // 绿色
      } else if (numericValue < 0) {
        return { color: '#F56C6C' } // 红色
      } else {
        return {} // 0或无效值保持默认颜色
      }
    },
    getTrendColorStyle(trendValue) {
      // 提取趋势数值
      let numericValue = 0
      if (typeof trendValue === 'string') {
        // 移除HTML标签和百分比符号，提取数字
        const cleanValue = trendValue.replace(/<[^>]*>/g, '').replace(/%/g, '')
        numericValue = parseFloat(cleanValue) || 0
      } else if (typeof trendValue === 'number') {
        numericValue = trendValue
      }
      
      // 根据趋势数值设置颜色
      if (numericValue > 0) {
        return { color: '#67C23A' } // 绿色
      } else if (numericValue < 0) {
        return { color: '#F56C6C' } // 红色
      } else {
        return { color: '#606266' } // 0保持默认颜色
      }
    },
    fetchData() {
      this.loading = true
      
      // 默认获取最近一年的数据
      request({
        url: '/api/analysis/monthly/comparison',
        method: 'get',
        params: {
          includeAll: false // 初始获取最近一年数据
        }
      }).then(response => {
        if (response.code === 200) {
          const data = response.data
          
          // 设置月份标签
          this.months = data.months.map(month => {
            const parts = month.match(/(\d{4})年(\d{2})月/)
            if (parts && parts.length === 3) {
              return `${parts[1]}/${parts[2]}`
            }
            return month
          })
          
          // 设置月度数据
          this.monthlyData = [
            { 
              month: '场次', 
              type: 'gameCount',
              values: data.gameCount.values || [],
              trends: data.gameCount.trends || []
            },
            { 
              month: '得分率', 
              type: 'scoreRate',
              values: data.scoreRate.values || [],
              trends: data.scoreRate.trends || []
            },
            { 
              month: '订正率', 
              type: 'fixRate',
              values: data.fixRate.values || [],
              trends: data.fixRate.trends || []
            },
            { 
              month: '复盘率', 
              type: 'reviewRate',
              values: data.reviewRate.values || [],
              trends: data.reviewRate.trends || []
            },
            { 
              month: '排位率', 
              type: 'rankRate',
              values: data.rankRate.values || [],
              trends: data.rankRate.trends || []
            },
            { 
              month: '掌握率', 
              type: 'masteryRate',
              values: data.masteryRate.values || [],
              trends: data.masteryRate.trends || []
            },
            { 
              month: '平均难度', 
              type: 'avgDifficulty',
              values: data.avgDifficulty.values || [],
              trends: data.avgDifficulty.trends || []
            }
          ]
          
          // 更新当前月份标签
          this.currentMonthLabel = this.months.length > 0 ? 
            this.months[0] : 
            this.getCurrentMonthLabel()
            
          // 设置最新月份的数据
          this.latestStats = data.latestStats || {}
          
          // 处理表格数据
          this.processTableData()
          
          // 初始化图表 - 使用nextTick确保DOM更新完成
          this.$nextTick(() => {
            setTimeout(() => {
              this.initChart()
            }, 100)
          })
        } else {
          this.$message.error(response.message || '获取数据失败')
        }
      }).catch(error => {
        console.error('获取月度环比数据失败:', error)
        this.$message.error('获取数据失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleTimeRangeChange() {
      const isAllData = this.timeRange === 'all';
      
      // 显示加载状态
      this.loading = true;
      
      // 发送请求获取对应时间范围的数据
      request({
        url: '/api/analysis/monthly/comparison',
        method: 'get',
        params: {
          includeAll: isAllData,
          _t: new Date().getTime() // 保留时间戳避免缓存
        }
      }).then(response => {
        if (response.code === 200) {
          const data = response.data;
          
          // 设置月份标签
          this.months = data.months.map(month => {
            const parts = month.match(/(\d{4})年(\d{2})月/);
            if (parts && parts.length === 3) {
              return `${parts[1]}/${parts[2]}`;
            }
            return month;
          });
          
          // 更新月度数据
          this.monthlyData = [
            { 
              month: '场次', 
              type: 'gameCount',
              values: data.gameCount.values || [],
              trends: data.gameCount.trends || []
            },
            { 
              month: '得分率', 
              type: 'scoreRate',
              values: data.scoreRate.values || [],
              trends: data.scoreRate.trends || []
            },
            { 
              month: '订正率', 
              type: 'fixRate',
              values: data.fixRate.values || [],
              trends: data.fixRate.trends || []
            },
            { 
              month: '复盘率', 
              type: 'reviewRate',
              values: data.reviewRate.values || [],
              trends: data.reviewRate.trends || []
            },
            { 
              month: '排位率', 
              type: 'rankRate',
              values: data.rankRate.values || [],
              trends: data.rankRate.trends || []
            },
            { 
              month: '掌握率', 
              type: 'masteryRate',
              values: data.masteryRate.values || [],
              trends: data.masteryRate.trends || []
            },
            { 
              month: '平均难度', 
              type: 'avgDifficulty',
              values: data.avgDifficulty.values || [],
              trends: data.avgDifficulty.trends || []
            }
          ];
          
          // 更新当前月份标签
          this.currentMonthLabel = this.months.length > 0 ? 
            this.months[0] : 
            this.getCurrentMonthLabel();
            
          // 更新最新月份的数据
          this.latestStats = data.latestStats || {};
          
          // 处理表格数据
          this.processTableData();
          
          // 更新图表 - 使用nextTick确保DOM更新完成
          this.$nextTick(() => {
            setTimeout(() => {
              this.initChart()
            }, 100)
          });
        } else {
          this.$message.error(response.message || '获取数据失败');
        }
      }).catch(error => {
        console.error('获取月度环比数据失败:', error);
        this.$message.error('获取数据失败，请稍后重试');
      }).finally(() => {
        this.loading = false;
      });
    },
    processTableData() {
      // 过滤出有数据的月份
      const monthsWithData = [];
      const monthIndices = [];
      
      // 检查每个月份是否至少有一个指标有实际数据
      this.months.forEach((month, monthIndex) => {
        // 检查这个月是否至少有一个指标有真实数据
        const hasData = this.monthlyData.some(indicator => {
          const value = indicator.values[monthIndex];
          // 包含任何非零值的月份
          return value !== null && value !== undefined && 
                 (indicator.type === 'gameCount' ? value > 0 : value > 0.0001);
        });
        
        // 如果有真实数据，记录这个月份和它的索引
        if (hasData) {
          monthsWithData.push(month);
          monthIndices.push(monthIndex);
        }
      });
      
      // 按照时间顺序排序月份（确保最新月份在前面）
      const sortedIndices = [...monthIndices].sort((a, b) => {
        const monthA = this.months[a];
        const monthB = this.months[b];
        return this.compareMonths(monthB, monthA); // 反向比较，最新的在前
      });
      
      // 设置表格列（指标名称）
      this.tableColumns = ['场次', '得分率', '订正率', '复盘率', '排位率', '掌握率', '平均难度'];
      
      // 指标配置：列名与类型映射，保持列顺序
      const metricConfigs = [
        { label: '场次', type: 'gameCount' },
        { label: '得分率', type: 'scoreRate' },
        { label: '订正率', type: 'fixRate' },
        { label: '复盘率', type: 'reviewRate' },
        { label: '排位率', type: 'rankRate' },
        { label: '掌握率', type: 'masteryRate' },
        { label: '平均难度', type: 'avgDifficulty' }
      ];
      
      // 预计算每个指标在所有月份中的最优值所在行索引（rowIndex）
      const bestRowIndexByType = {};
      metricConfigs.forEach(config => {
        const dataItem = this.monthlyData.find(item => item.type === config.type);
        if (!dataItem) return;
        
        let bestIndex = -1;
        if (config.type === 'rankRate') {
          // 排位率是越小越好
          let minValue = Number.MAX_VALUE;
          sortedIndices.forEach((monthIndex, rowIndex) => {
            const v = dataItem.values[monthIndex];
            if (v !== null && v !== undefined && v > 0.0001 && v < minValue) {
              minValue = v;
              bestIndex = rowIndex;
            }
          });
        } else if (config.type === 'gameCount') {
          // 场次是越多越好
          let maxValue = -1;
          sortedIndices.forEach((monthIndex, rowIndex) => {
            const v = dataItem.values[monthIndex];
            if (v !== null && v !== undefined && v > maxValue) {
              maxValue = v;
              bestIndex = rowIndex;
            }
          });
        } else {
          // 其他指标都是越大越好
          let maxValue = -1;
          sortedIndices.forEach((monthIndex, rowIndex) => {
            const v = dataItem.values[monthIndex];
            if (v !== null && v !== undefined && v > maxValue) {
              maxValue = v;
              bestIndex = rowIndex;
            }
          });
        }
        
        bestRowIndexByType[config.type] = bestIndex;
      });
      
      // 准备表格数据（每行代表一个月份）
      this.tableData = [];
      
      // 为每个有数据的月份创建一行
      sortedIndices.forEach((monthIndex, rowIndex) => {
        const month = this.months[monthIndex];
        const row = { month: month };
        
        metricConfigs.forEach((config, colIndex) => {
          const dataItem = this.monthlyData.find(item => item.type === config.type);
          const value = dataItem ? dataItem.values[monthIndex] : null;
          const trend = dataItem ? dataItem.trends[monthIndex] : null;
          
          if (value !== null && value !== undefined) {
            // 格式化显示值
            const formattedValue = config.type === 'gameCount'
              ? (value || '-')
              : this.formatPercent(value);
            
            // 检查是否为最优值
            const isNonZeroValue = config.type === 'gameCount' ? value > 0 : value > 0.0001;
            const bestRowIndex = bestRowIndexByType[config.type];
            if (isNonZeroValue && bestRowIndex === rowIndex) {
              row[`value${colIndex}`] = `👑<span style="font-weight: bold;">${formattedValue}</span>`;
            } else {
              row[`value${colIndex}`] = formattedValue;
            }
            
            // 处理趋势（排位率趋势取反，其他指标保持不变）
            if (config.type === 'rankRate') {
              row[`trend${colIndex}`] = trend !== null && trend !== undefined ? -trend : null;
            } else {
              row[`trend${colIndex}`] = trend;
            }
          } else {
            // 如果单个指标没有数据则显示为'-'
            row[`value${colIndex}`] = '-';
            row[`trend${colIndex}`] = null;
          }
        });
        
        this.tableData.push(row);
      });
    },
    getCurrentMonthLabel() {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1
      return `${year}/${month < 10 ? '0' + month : month}`
    },
    initChart() {
      if (!this.$refs.chartContainer) {
        return
      }
      
      // 确保容器有尺寸
      const container = this.$refs.chartContainer
      if (container.offsetWidth === 0 || container.offsetHeight === 0) {
        setTimeout(() => {
          this.initChart()
        }, 200)
        return
      }
      
      if (this.chart) {
        this.chart.dispose()
      }
      
      try {
        this.chart = echarts.init(this.$refs.chartContainer)
        
        // 延迟设置实际图表
        setTimeout(() => {
          this.updateChart()
        }, 100)
        
      } catch (error) {
        console.error('Chart initialization failed:', error)
      }
    },
    updateChart() {
      if (!this.chart) {
        return
      }
      
      // 过滤出有数据的月份（与表格使用相同的过滤逻辑）
      const monthsWithData = [];
      const monthIndices = [];
      
      // 检查每个月份是否至少有一个指标有实际数据
      this.months.forEach((month, monthIndex) => {
        const hasData = this.monthlyData.some(indicator => {
          const value = indicator.values[monthIndex];
          return value !== null && value !== undefined && 
                 (indicator.type === 'gameCount' ? value > 0 : value > 0.0001);
        });
        
        if (hasData) {
          monthsWithData.push(month);
          monthIndices.push(monthIndex);
        }
      });
      
      // 按照时间顺序排序月份（与表格保持一致，最新月份在前）
      const sortedIndices = [...monthIndices].sort((a, b) => {
        const monthA = this.months[a];
        const monthB = this.months[b];
        return this.compareMonths(monthB, monthA); // 反向比较，最新的在前
      });
      
      // 准备图表数据（只包含有数据的月份）
      const filteredMonths = sortedIndices.map(index => this.months[index]);
      const series = [];
      const gameCountData = [];
      
      // 准备场次数据（柱状图）
      const gameCountItem = this.monthlyData.find(item => item.type === 'gameCount');
      sortedIndices.forEach((monthIndex, i) => {
        gameCountData[i] = gameCountItem ? gameCountItem.values[monthIndex] : 0;
      });
      
      // 指标配置：名称、颜色、使用的Y轴
      const metricConfigs = [
        { type: 'scoreRate', name: '得分率', color: '#1890FF', yAxisIndex: 0 },
        { type: 'fixRate', name: '订正率', color: '#2FC25B', yAxisIndex: 0 },
        { type: 'reviewRate', name: '复盘率', color: '#13C2C2', yAxisIndex: 0 },
        { type: 'masteryRate', name: '掌握率', color: '#FACC14', yAxisIndex: 0 },
        { type: 'avgDifficulty', name: '平均难度', color: '#722ED1', yAxisIndex: 0 },
        { type: 'rankRate', name: '排位率', color: '#FF4D4F', yAxisIndex: 1 }
      ];
      
      // 添加折线图系列
      metricConfigs.forEach(config => {
        const item = this.monthlyData.find(m => m.type === config.type);
        if (!item) return;
        
        const data = [];
        sortedIndices.forEach(monthIndex => {
          data.push(item.values[monthIndex]);
        });
        
        series.push({
          name: config.name,
          type: 'line',
          data: data,
          yAxisIndex: config.yAxisIndex,
          symbol: 'circle',
          symbolSize: 6, // 移动端稍微小一点
          smooth: true,
          lineStyle: {
            width: 2,
            color: config.color
          },
          itemStyle: {
            color: config.color
          }
        });
      });
      
      // 最后添加场次柱状图
      series.push({
        name: '场次',
        type: 'bar',
        yAxisIndex: 2, // 使用第三个Y轴
        data: gameCountData,
        barWidth: 15, // 移动端稍微窄一点
        itemStyle: {
          color: '#FFA500'
        }
      });
      
      // 计算场次的合适刻度
      const maxGameCount = Math.max(...gameCountData.filter(v => v !== null && v !== undefined));
      const gameCountInterval = this.calculateAppropriateInterval(maxGameCount);
      
      // 设置图表选项
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
          },
          textStyle: {
            fontSize: 11
          },
          formatter: function(params) {
            let result = params[0].axisValueLabel + '<br/>';
            
            params.forEach(param => {
              const marker = param.marker;
              const seriesName = param.seriesName;
              const value = param.value;
              
              if (seriesName === '场次') {
                result += marker + seriesName + ': ' + value + '<br/>';
              } else {
                // 所有百分比数据都保留两位小数
                result += marker + seriesName + ': ' + (value * 100).toFixed(2) + '%<br/>';
              }
            });
            
            return result;
          }
        },
        legend: {
          data: ['场次', '得分率', '订正率', '复盘率', '排位率', '掌握率', '平均难度'],
          bottom: 10,
          textStyle: {
            fontSize: 11 // 移动端字体稍小
          },
          itemWidth: 12,
          itemHeight: 8,
          itemGap: 8,
          formatter: function(name) {
            // 将图例分成两行，每行三个
            const legendMap = {
              '场次': '场次',
              '得分率': '得分率', 
              '订正率': '订正率',
              '排位率': '排位率',
              '掌握率': '掌握率',
              '平均难度': '平均难度'
            }
            return legendMap[name] || name
          }
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '15%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: filteredMonths, // 使用排序后的月份
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            fontSize: 10 // 移动端字体稍小
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '百分比',
            min: 0,
            max: 1,
            interval: 0.2,
            position: 'left',
            axisLabel: {
              formatter: function(value) {
                return (value * 100).toFixed(0) + '%';
              },
              fontSize: 10,
              margin: 0
            },
            nameTextStyle: {
              align: 'left',
              padding: [0, 0, 0, -20],
              fontSize: 10
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#eee'
              }
            }
          },
          {
            type: 'value',
            name: '排位',
            min: 0,
            max: 1,
            interval: 0.2,
            position: 'left',
            offset: 40,
            inverse: true,
            axisLabel: {
              formatter: function(value) {
                return (value * 100).toFixed(0) + '%';
              },
              fontSize: 10,
              margin: -15
            },
            nameLocation: 'start',
            nameGap: 5,
            nameTextStyle: {
              align: 'left',
              color: '#FF4D4F',
              padding: [0, 0, 10, -5],
              fontSize: 10
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#FF4D4F'
              }
            }
          },
          {
            type: 'value',
            name: '场次',
            min: 0,
            max: maxGameCount + gameCountInterval,
            interval: gameCountInterval,
            position: 'right',
            axisLabel: {
              formatter: '{value}',
              fontSize: 10,
              margin: 20
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#FFA500'
              }
            },
            nameTextStyle: {
              color: '#FFA500',
              padding: [0, 0, 0, 60],
              fontSize: 10
            }
          }
        ],
        series: series
      };
      
      try {
        this.chart.setOption(option, true);
      } catch (error) {
        console.error('Failed to set chart option:', error)
      }
    },
    resizeChart() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    formatPercent(value) {
      if (value === undefined || value === null) return '-'
      return (value * 100).toFixed(2) + '%'
    },
    formatTrend(value) {
      if (value === undefined || value === null || value === '-') return '-'
      return (value >= 0 ? '+' : '') + value.toFixed(2) + '%'
    },
    formatTrendArrow(value) {
      if (value === undefined || value === null || value === '-') return '-'
      return value > 0 ? '↑ ' + value.toFixed(2) + '%' : 
             value < 0 ? '↓ ' + Math.abs(value).toFixed(2) + '%' : '-'
    },
    getTrendClass(value) {
      if (value === undefined || value === null || value === '-') return ''
      if (value === 0) return 'trend-zero'
      return value > 0 ? 'trend-up' : 'trend-down'
    },
    calculateAppropriateInterval(maxValue) {
      if (maxValue <= 0) return 1;
      
      // 找到合适的基数和倍数
      const magnitude = Math.pow(10, Math.floor(Math.log10(maxValue)));
      const normalized = maxValue / magnitude;
      
      // 根据规范化后的值选择合适的间隔
      let interval;
      if (normalized <= 1.5) interval = 0.2 * magnitude;
      else if (normalized <= 3) interval = 0.5 * magnitude;
      else if (normalized <= 7) interval = 1 * magnitude;
      else interval = 2 * magnitude;
      
      // 确保至少有5个刻度点
      if (maxValue / interval > 15) interval = interval * 2;
      if (maxValue / interval < 4) interval = interval / 2;
      
      return interval;
    },
    compareMonths(monthA, monthB) {
      // 假设月份格式为 YYYY/MM
      const [yearA, monthNumA] = monthA.split('/')
      const [yearB, monthNumB] = monthB.split('/')
      
      if (yearA !== yearB) {
        return parseInt(yearA) - parseInt(yearB)
      }
      return parseInt(monthNumA) - parseInt(monthNumB)
    },
    getDifficultyColorByPercentage(percentage) {
      if (percentage <= 14.29) {
        return '#F56C6C'; // 红题
      } else if (percentage <= 28.58) {
        return '#E6A23C'; // 橙题
      } else if (percentage <= 42.87) {
        return '#F7BA2A'; // 黄题
      } else if (percentage <= 57.15) {
        return '#67C23A'; // 绿题
      } else if (percentage <= 71.44) {
        return '#409EFF'; // 蓝题
      } else if (percentage <= 85.72) {
        return '#8E44AD'; // 紫题
      } else {
        return '#2C3E50'; // 黑题
      }
    },
    getDifficultyLevelByPercentage(percentage) {
      if (percentage <= 14.29) {
        return '红题难度';
      } else if (percentage <= 28.58) {
        return '橙题难度';
      } else if (percentage <= 42.87) {
        return '黄题难度';
      } else if (percentage <= 57.15) {
        return '绿题难度';
      } else if (percentage <= 71.44) {
        return '蓝题难度';
      } else if (percentage <= 85.72) {
        return '紫题难度';
      } else {
        return '黑题难度';
      }
    },
    extractNumericValue(value) {
      if (typeof value === 'number') {
        return value;
      }
      
      if (typeof value === 'string') {
        // 移除HTML标签
        const textOnly = value.replace(/<[^>]*>/g, '');
        // 提取百分号之前的数字
        const match = textOnly.match(/(\d+(\.\d+)?)/);
        return match ? parseFloat(match[1]) / 100 : 0;
      }
      
      return 0;
    },
    formatPercentWithoutHTML(value) {
      if (value === undefined || value === null) return '-';
      
      if (typeof value === 'number') {
        return (value * 100).toFixed(2) + '%';
      }
      
      if (typeof value === 'string') {
        // 移除HTML标签
        const textOnly = value.replace(/<[^>]*>/g, '');
        // 直接返回文本形式
        return textOnly;
      }
      
      return '-';
    },
    fixTooltipWidth() {
      // 延迟执行，确保tooltip已经渲染
      this.$nextTick(() => {
        setTimeout(() => {
          const tooltips = document.querySelectorAll('.el-tooltip__popper');
          tooltips.forEach(tooltip => {
            tooltip.style.width = '250px';
            tooltip.style.maxWidth = '250px';
            tooltip.style.minWidth = '250px';
            tooltip.style.boxSizing = 'border-box';
            tooltip.style.left = '50%';
            tooltip.style.transform = 'translateX(-50%)';
            
            // 强制设置颜色块的样式
            const colorBlocks = tooltip.querySelectorAll('.level-color');
            colorBlocks.forEach((block, index) => {
              const colors = ['#F56C6C', '#E6A23C', '#F7BA2A', '#67C23A', '#409EFF', '#8E44AD', '#2C3E50'];
              if (colors[index]) {
                block.style.setProperty('display', 'inline-block', 'important');
                block.style.setProperty('width', '14px', 'important');
                block.style.setProperty('height', '14px', 'important');
                block.style.setProperty('border-radius', '2px', 'important');
                block.style.setProperty('margin-right', '6px', 'important');
                block.style.setProperty('background-color', colors[index], 'important');
                block.style.setProperty('border', '1px solid rgba(255, 255, 255, 0.3)', 'important');
              }
            });
          });
        }, 100);
      });
    }
  }
}
</script>

<style scoped>
.monthly-comparison-mobile {
  padding: 8px 0;
  position: relative;
}

/* 全局样式重置，确保网格布局不被覆盖 */
.monthly-comparison-mobile * {
  box-sizing: border-box;
}

/* 时间范围切换按钮 */
.time-range-btn {
  position: fixed !important;
  right: 15px !important;
  bottom: 95px !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
  background-color: rgba(255, 255, 255, 0.5) !important;
  color: #409eff !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  font-size: 20px !important;
  font-weight: bold !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 9999 !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
}

.time-range-btn-text {
  font-size: 20px !important;
  font-weight: bold !important;
  line-height: 1 !important;
}

.time-range-btn:hover, .time-range-btn:focus {
  background-color: rgba(255, 255, 255, 0.8) !important;
  transform: scale(1.05) !important;
}

.time-range-btn:active {
  background-color: rgba(255, 255, 255, 0.9) !important;
  transform: scale(0.95) !important;
}

.time-range-btn.active {
  background-color: #409eff !important;
  color: white !important;
}

.time-range-btn.active:hover, .time-range-btn.active:focus {
  background-color: #66b1ff !important;
  transform: scale(1.05) !important;
}

.time-range-btn.active:active {
  background-color: #3a8ee6 !important;
  transform: scale(0.95) !important;
}

/* 暗色模式 */
@media (prefers-color-scheme: dark) {
  .time-range-btn {
    background-color: rgba(30, 30, 30, 0.5) !important;
    color: #67b3fd !important;
  }
  
  .time-range-btn:hover, .time-range-btn:focus {
    background-color: rgba(40, 40, 40, 0.8) !important;
  }
  
  .time-range-btn:active {
    background-color: rgba(50, 50, 50, 0.9) !important;
  }
  
  .time-range-btn.active {
    background-color: #409eff !important;
    color: white !important;
  }
  
  .time-range-btn.active:hover, .time-range-btn.active:focus {
    background-color: #66b1ff !important;
  }
  
  .time-range-btn.active:active {
    background-color: #3a8ee6 !important;
  }
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 20px;
  height: 16px;
  box-sizing: content-box;
  background-color: #2E365A;
  color: #ffffff;
  border-radius: 8px 8px 0 0;
}

.data-card {
  margin-bottom: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

/* 强制覆盖Element UI的默认padding */
:deep(.el-card__body) {
  padding: 0 !important;
}

/* 使用更强的选择器 */
.monthly-comparison-mobile :deep(.el-card__body) {
  padding: 0 !important;
}

/* 针对所有el-card的body */
:deep(.el-card) :deep(.el-card__body) {
  padding: 0 !important;
}



.overview-content {
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.overview-grid {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  grid-template-rows: repeat(2, 1fr) !important;
  gap: 10px !important;
  width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  justify-content: center !important;
  align-items: center !important;
  max-width: 350px !important;
}

.stat-item {
  text-align: center !important;
  padding: 8px 4px !important;
  border-radius: 8px !important;
  background-color: #f9f9f9 !important;
  height: 95px !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  min-height: 95px !important;
  border: 1px solid #e4e7ed !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08) !important;
  transition: all 0.2s ease !important;
}



.stat-label {
  font-size: 12px !important;
  color: #606266 !important;
  margin-bottom: 8px !important;
  line-height: 1.2 !important;
  font-weight: 500 !important;
}

.stat-value {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #303133 !important;
  margin-bottom: 4px !important;
  line-height: 1.2 !important;
}

.stat-trend {
  font-size: 10px !important;
  line-height: 1.2 !important;
  font-weight: 500 !important;
}

.trend-up {
  color: #67C23A !important;
}

.trend-down {
  color: #F56C6C !important;
}

.trend-zero {
  color: #909399 !important;
}

/* 强制覆盖内联样式 - 使用更强的选择器 */
.monthly-comparison-mobile .stat-trend.trend-up {
  color: #67C23A !important;
}

.monthly-comparison-mobile .stat-trend.trend-down {
  color: #F56C6C !important;
}

.monthly-comparison-mobile .stat-trend.trend-zero {
  color: #909399 !important;
}

/* 表格中的趋势指示器样式 */
.monthly-comparison-mobile .trend-indicator.trend-up {
  color: #67C23A !important;
}

.monthly-comparison-mobile .trend-indicator.trend-down {
  color: #F56C6C !important;
}

.monthly-comparison-mobile .trend-indicator.trend-zero {
  color: #909399 !important;
}

/* 全局强制覆盖 */
* .trend-up {
  color: #67C23A !important;
}

* .trend-down {
  color: #F56C6C !important;
}

* .trend-zero {
  color: #909399 !important;
}

.trend-indicator {
  font-size: 10px;
  margin-top: 3px;
}

.chart-container {
  height: 320px;
  width: 100%;
  min-height: 320px;
  display: block;
  position: relative;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  margin: 0 !important;
  /* 保留滚动条，不要隐藏 */
}

/* 隐藏Webkit浏览器的滚动条 */
.table-wrapper::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

/* 隐藏整个页面的滚动条 */
::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

/* 隐藏所有元素的滚动条 */
* {
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE and Edge */
}

*::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

/* 针对Element UI表格的滚动条隐藏 */
.el-table__body-wrapper::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

.el-table__body-wrapper {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

/* 针对卡片内容的滚动条隐藏 */
.el-card__body::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

.el-card__body {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

/* 针对移动端页面的滚动条隐藏 */
.monthly-comparison-mobile::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

.monthly-comparison-mobile {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

/* 针对body和html的滚动条隐藏 */
body::-webkit-scrollbar,
html::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

body,
html {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

/* 针对整个页面的滚动条隐藏 */
#app::-webkit-scrollbar,
.app::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

#app,
.app {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

/* 针对所有可能的滚动容器 */
.overflow-auto::-webkit-scrollbar,
.overflow-x-auto::-webkit-scrollbar,
.overflow-y-auto::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

.overflow-auto,
.overflow-x-auto,
.overflow-y-auto {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

/* 全局强制隐藏所有滚动条 */
*::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
}

* {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

/* 针对特定浏览器的滚动条隐藏 */
::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

::-webkit-scrollbar-track {
  display: none !important;
}

::-webkit-scrollbar-thumb {
  display: none !important;
}

::-webkit-scrollbar-corner {
  display: none !important;
}

/* 更强制的滚动条隐藏 */
html::-webkit-scrollbar,
body::-webkit-scrollbar,
#app::-webkit-scrollbar,
.app::-webkit-scrollbar,
.monthly-comparison-mobile::-webkit-scrollbar,
.el-card::-webkit-scrollbar,
.el-card__body::-webkit-scrollbar,
.el-table::-webkit-scrollbar,
.el-table__body-wrapper::-webkit-scrollbar,
.table-wrapper::-webkit-scrollbar,
.overview-content::-webkit-scrollbar,
.overview-grid::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
}

html,
body,
#app,
.app,
.monthly-comparison-mobile,
.el-card,
.el-card__body,
.el-table,
.el-table__body-wrapper,
.table-wrapper,
.overview-content,
.overview-grid {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

/* 针对所有可能的滚动容器 */
[class*="scroll"]::-webkit-scrollbar,
[class*="overflow"]::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

[class*="scroll"],
[class*="overflow"] {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

/* 使用CSS变量强制隐藏滚动条 */
:root {
  --scrollbar-width: 0px !important;
  --scrollbar-height: 0px !important;
}

/* 针对所有元素的滚动条隐藏 */
*::-webkit-scrollbar {
  width: var(--scrollbar-width) !important;
  height: var(--scrollbar-height) !important;
  display: none !important;
  background: transparent !important;
}

*::-webkit-scrollbar-track {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

*::-webkit-scrollbar-thumb {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

*::-webkit-scrollbar-corner {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

/* 针对特定浏览器的滚动条隐藏 */
::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  display: none !important;
  background: transparent !important;
}

::-webkit-scrollbar-track {
  width: 0 !important;
  height: 0 !important;
  display: none !important;
}

::-webkit-scrollbar-thumb {
  width: 0 !important;
  height: 0 !important;
  display: none !important;
}

::-webkit-scrollbar-corner {
  width: 0 !important;
  height: 0 !important;
  display: none !important;
}

/* 强制隐藏所有滚动条 - 最高优先级 */
html::-webkit-scrollbar,
body::-webkit-scrollbar,
#app::-webkit-scrollbar,
.app::-webkit-scrollbar,
.monthly-comparison-mobile::-webkit-scrollbar,
.el-card::-webkit-scrollbar,
.el-card__body::-webkit-scrollbar,
.el-table::-webkit-scrollbar,
.el-table__body-wrapper::-webkit-scrollbar,
.table-wrapper::-webkit-scrollbar,
.overview-content::-webkit-scrollbar,
.overview-grid::-webkit-scrollbar,
*::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
}

/* 最强制的滚动条隐藏 - 使用更具体的选择器 */
html::-webkit-scrollbar,
body::-webkit-scrollbar,
#app::-webkit-scrollbar,
.app::-webkit-scrollbar,
.monthly-comparison-mobile::-webkit-scrollbar,
.el-card::-webkit-scrollbar,
.el-card__body::-webkit-scrollbar,
.el-table::-webkit-scrollbar,
.el-table__body-wrapper::-webkit-scrollbar,
.table-wrapper::-webkit-scrollbar,
.overview-content::-webkit-scrollbar,
.overview-grid::-webkit-scrollbar,
*::-webkit-scrollbar,
::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
  opacity: 0 !important;
}

/* 针对所有可能的滚动条组件 */
html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track,
#app::-webkit-scrollbar-track,
.app::-webkit-scrollbar-track,
.monthly-comparison-mobile::-webkit-scrollbar-track,
.el-card::-webkit-scrollbar-track,
.el-card__body::-webkit-scrollbar-track,
.el-table::-webkit-scrollbar-track,
.el-table__body-wrapper::-webkit-scrollbar-track,
.table-wrapper::-webkit-scrollbar-track,
.overview-content::-webkit-scrollbar-track,
.overview-grid::-webkit-scrollbar-track,
*::-webkit-scrollbar-track,
::-webkit-scrollbar-track {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb,
#app::-webkit-scrollbar-thumb,
.app::-webkit-scrollbar-thumb,
.monthly-comparison-mobile::-webkit-scrollbar-thumb,
.el-card::-webkit-scrollbar-thumb,
.el-card__body::-webkit-scrollbar-thumb,
.el-table::-webkit-scrollbar-thumb,
.el-table__body-wrapper::-webkit-scrollbar-thumb,
.table-wrapper::-webkit-scrollbar-thumb,
.overview-content::-webkit-scrollbar-thumb,
.overview-grid::-webkit-scrollbar-thumb,
*::-webkit-scrollbar-thumb,
::-webkit-scrollbar-thumb {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

html::-webkit-scrollbar-corner,
body::-webkit-scrollbar-corner,
#app::-webkit-scrollbar-corner,
.app::-webkit-scrollbar-corner,
.monthly-comparison-mobile::-webkit-scrollbar-corner,
.el-card::-webkit-scrollbar-corner,
.el-card__body::-webkit-scrollbar-corner,
.el-table::-webkit-scrollbar-corner,
.el-table__body-wrapper::-webkit-scrollbar-corner,
.table-wrapper::-webkit-scrollbar-corner,
.overview-content::-webkit-scrollbar-corner,
.overview-grid::-webkit-scrollbar-corner,
*::-webkit-scrollbar-corner,
::-webkit-scrollbar-corner {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

html,
body,
#app,
.app {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
  overflow-x: auto;
  overflow-y: auto;
}

.monthly-comparison-mobile,
.el-card,
.el-card__body,
.el-table,
.el-table__body-wrapper,
.table-wrapper,
.overview-content,
.overview-grid {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

.el-table {
  min-width: 100%;
  font-size: 12px;
}

/* 表格中数值的字体大小 */
.monthly-comparison-mobile .el-table td {
  font-size: 12px !important;
}

.monthly-comparison-mobile .el-table th {
  font-size: 12px !important;
}

/* 强制覆盖Element UI的默认样式 */
:deep(.el-table) td {
  font-size: 12px !important;
}

:deep(.el-table) th {
  font-size: 12px !important;
}

/* 针对所有表格元素的字体大小 */
.el-table__body td,
.el-table__header th {
  font-size: 12px !important;
}

/* 强制设置表格内所有文本的字体大小 */
.monthly-comparison-mobile .el-table * {
  font-size: 12px !important;
}

/* 针对表格单元格的强制字体设置 */
.monthly-comparison-mobile .el-table .cell {
  font-size: 12px !important;
}

/* 针对趋势指示器的字体设置 */
.monthly-comparison-mobile .trend-indicator {
  font-size: 12px !important;
}

/* 环比数据颜色样式 */
.value-positive {
  color: #67C23A !important; /* 绿色 */
}

.value-negative {
  color: #F56C6C !important; /* 红色 */
}

.value-zero {
  color: inherit !important; /* 保持默认颜色 */
}

/* 月份显示样式 */
.month-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.1;
  padding: 2px 0;
}

.month-day {
  font-size: 13px;
  font-weight: bold;
  color: #303133;
}

.month-year {
  font-size: 9px;
  color: #909399;
  margin-top: 1px;
}

.el-table td, .el-table th {
  padding: 8px 4px;
}

.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fafafa;
}

.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f5f7fa;
}

.el-table--border th, .el-table--border td {
  border-right: 1px solid #ebeef5;
}

.el-table::before {
  height: 1px;
  background-color: #ebeef5;
}

.el-table--border::after, 
.el-table--group::after,
.el-table::before {
  background-color: #ebeef5;
}

.el-table__body tr:nth-child(even) > td {
  background-color: #fafafa;
}

.el-table__body tr:nth-child(odd) > td {
  background-color: #ffffff;
}

/* 横屏适配 */
@media (orientation: landscape) {
  .overview-grid {
    grid-template-columns: repeat(6, 1fr) !important;
    gap: 8px !important;
  }
  
  .stat-item {
    padding: 10px 6px !important;
    min-height: 70px !important;
  }
  
  .stat-label {
    font-size: 11px !important;
    margin-bottom: 6px !important;
  }
  
  .stat-value {
    font-size: 16px !important;
    margin-bottom: 3px !important;
  }
  
  .stat-trend {
    font-size: 9px !important;
  }
  
  .chart-container {
    height: 280px;
  }
  
  /* 移动端滚动条隐藏 */
  .table-wrapper::-webkit-scrollbar,
  .el-table__body-wrapper::-webkit-scrollbar,
  .el-card__body::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  
  .table-wrapper,
  .el-table__body-wrapper,
  .el-card__body {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }
  
  /* 移动端全局滚动条隐藏 */
  *::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
    background: transparent !important;
  }
  
  *::-webkit-scrollbar-track {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  
  *::-webkit-scrollbar-thumb {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  
  *::-webkit-scrollbar-corner {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  
  * {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }
  
  /* 移动端页面滚动条隐藏 */
  body::-webkit-scrollbar,
  html::-webkit-scrollbar,
  #app::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
    background: transparent !important;
  }
  
  body,
  html,
  #app {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }
  
  /* 移动端CSS变量 */
  :root {
    --scrollbar-width: 0px !important;
    --scrollbar-height: 0px !important;
  }
  
  /* 移动端强制隐藏所有滚动条 */
  ::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
    background: transparent !important;
  }
  
  ::-webkit-scrollbar-track {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  
  ::-webkit-scrollbar-thumb {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  
  ::-webkit-scrollbar-corner {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  
  *::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
    background: transparent !important;
  }
  
  *::-webkit-scrollbar-track {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  
  *::-webkit-scrollbar-thumb {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  
  *::-webkit-scrollbar-corner {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
}

/* 小屏幕设备优化 */
@media (max-width: 375px) {
  .overview-grid {
    gap: 8px !important;
  }
  
  .stat-item {
    padding: 10px 6px !important;
    min-height: 75px !important;
  }
  
  .stat-label {
    font-size: 11px !important;
    margin-bottom: 6px !important;
  }
  
  .stat-value {
    font-size: 16px !important;
    margin-bottom: 3px !important;
  }
  
  .stat-trend {
    font-size: 9px !important;
  }
  
  .chart-container {
    height: 300px;
  }
  
  .el-table {
    font-size: 11px;
  }
  
  .el-table td, .el-table th {
    padding: 6px 3px;
  }
}

/* 难度提示框样式 */
.difficulty-tooltip {
  width: 250px !important;
  max-width: 250px !important;
  min-width: 250px !important;
  padding: 0 !important;
  border-radius: 6px !important;
  box-sizing: border-box !important;
}

/* 强制覆盖Element UI的默认样式 */
.el-tooltip__popper.difficulty-tooltip {
  width: 250px !important;
  max-width: 250px !important;
  min-width: 250px !important;
  box-sizing: border-box !important;
}

/* 全局强制覆盖所有tooltip样式 */
.el-tooltip__popper {
  max-width: 250px !important;
  width: 250px !important;
  box-sizing: border-box !important;
}

/* 针对特定ID的tooltip */
#el-tooltip-7159,
div[id^="el-tooltip-"] {
  max-width: 250px !important;
  width: 250px !important;
  box-sizing: border-box !important;
}

.difficulty-tooltip-content {
  padding: 12px;
}

.difficulty-description {
  margin-bottom: 10px;
}

.difficulty-description p {
  margin: 0 0 5px 0;
  line-height: 1.5;
  font-size: 12px;
  text-align: left;
  word-wrap: break-word !important;
  word-break: break-word !important;
  white-space: normal !important;
  overflow-wrap: break-word !important;
}

.difficulty-levels {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.difficulty-level {
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 12px;
}

.level-color {
  display: inline-block !important;
  width: 14px !important;
  height: 14px !important;
  border-radius: 2px !important;
  margin-right: 6px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}



.level-range {
  width: 110px;
  display: inline-block;
  font-weight: bold;
}

.level-name {
  flex: 1;
}

/* 在小屏幕设备上显示时间范围切换按钮 */
@media (max-width: 768px) {
  .time-range-btn {
    display: flex !important;
  }
}

/* PC端隐藏按钮 */
@media (min-width: 769px) {
  .time-range-btn {
    display: none !important;
  }
}

/* PC端隐藏按钮 */
@media (min-width: 769px) {
  .time-range-btn {
    display: none !important;
  }
}

/* 移动端特定优化 */
@media (max-width: 768px) {
  .monthly-comparison-mobile {
    padding: 4px 0;
  }
  
  .data-card {
    margin-bottom: 12px;
    border-radius: 6px;
    
    :deep(.el-card__body) {
      padding: 20px 0 !important;
    }
  }
  
  .overview-card {
    margin-bottom: 12px;
    border-radius: 6px;
  }
  
  .overview-grid {
    gap: 10px !important;
    padding: 12px !important;
  }
  
  .stat-item {
    min-height: 60px !important;
    padding: 8px 4px !important;
  }
  
  .stat-label {
    font-size: 11px !important;
    margin-bottom: 4px !important;
  }
  
  .stat-value {
    font-size: 16px !important;
    margin-bottom: 2px !important;
  }
  
  .stat-trend {
    font-size: 9px !important;
  }
  
  .card-header {
    font-size: 13px;
    padding: 8px 12px;
  }
  
  .overview-content {
    padding: 8px 0;
  }
  
  .overview-grid {
    gap: 8px !important;
  }
  
  .stat-item {
    padding: 10px 6px !important;
    min-height: 75px !important;
    border-radius: 4px !important;
  }
  
  .stat-label {
    font-size: 11px !important;
    margin-bottom: 6px !important;
  }
  
  .stat-value {
    font-size: 16px !important;
    margin-bottom: 3px !important;
  }
  
  .stat-trend {
    font-size: 9px !important;
  }
  
  .chart-container {
    height: 300px;
  }
  
  .table-wrapper {
    margin: 0 -12px;
  }
  
  .el-table {
    font-size: 11px;
  }
  
  .el-table td, .el-table th {
    padding: 6px 3px;
  }
}

:deep(.el-card__header) {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 17px 20px !important;
  height: 16px !important;
  box-sizing: content-box !important;
  background-color: #2E365A !important;
  color: #ffffff !important;
  border-radius: 8px 8px 0 0 !important;
}

.monthly-comparison-mobile .el-card__header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 17px 20px !important;
  height: 16px !important;
  box-sizing: content-box !important;
  background-color: #2E365A !important;
  color: #ffffff !important;
  border-radius: 8px 8px 0 0 !important;
  font-size: 16px !important;
}

:deep(.el-card__body),
.monthly-comparison-mobile :deep(.el-card__body),
.monthly-comparison-mobile .el-card__body {
  padding: 0 !important;
}

.monthly-comparison-mobile .el-card__header span {
  font-size: 16px !important;
}

@media (max-width: 1024px) {
  .el-table__fixed-right {
    display: none !important;
    width: 0 !important;
  }
  .el-table__body-wrapper {
    margin-right: 0 !important;
    overflow-x: auto !important;
  }
}


</style>

<style>
/* 修复 tooltip 色块颜色问题 - 非 scoped 样式 */
.el-tooltip__popper .level-color {
  background-color: inherit !important;
}

/* 确保内联样式生效 */
.el-tooltip__popper .level-color[style*="background-color"] {
  background-color: inherit !important;
}

/* 强制覆盖 Element UI dark effect 的影响 */
.el-tooltip__popper[data-effect="dark"] .level-color {
  background-color: inherit !important;
}

/* 针对每个具体颜色的强制覆盖 */
.el-tooltip__popper .level-color[style*="background-color: #F56C6C"] {
  background-color: #F56C6C !important;
}
.el-tooltip__popper .level-color[style*="background-color: #E6A23C"] {
  background-color: #E6A23C !important;
}
.el-tooltip__popper .level-color[style*="background-color: #F7BA2A"] {
  background-color: #F7BA2A !important;
}
.el-tooltip__popper .level-color[style*="background-color: #67C23A"] {
  background-color: #67C23A !important;
}
.el-tooltip__popper .level-color[style*="background-color: #409EFF"] {
  background-color: #409EFF !important;
}
.el-tooltip__popper .level-color[style*="background-color: #8E44AD"] {
  background-color: #8E44AD !important;
}
.el-tooltip__popper .level-color[style*="background-color: #2C3E50"] {
  background-color: #2C3E50 !important;
}
</style>